export default __webpack_public_path__ + "static/media/1721.61a6b14a.png";